import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { Loader2, Lock, LogIn } from "lucide-react";

export default function AdminPage() {
  const { user, loading } = useAuth();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-oak-dark"><Loader2 className="w-8 h-8 animate-spin text-brass" /></div>;
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-oak-dark px-6">
        <div className="text-center max-w-sm">
          <Lock className="w-10 h-10 mx-auto text-brass mb-4" />
          <h1 className="font-serif text-3xl text-cream">Area riservata</h1>
          <p className="text-cream/70 mt-2 mb-6">Accedi per gestire menù, eventi, storia e contenuti del Ristorante Masetti.</p>
          <Button onClick={login} className="bg-brass hover:bg-brass-hover text-oak-dark rounded-full px-6 h-12" data-testid="admin-login-btn"><LogIn className="w-4 h-4 mr-2" />Accedi con Google</Button>
        </div>
      </div>
    );
  }

  if (!user.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-oak-dark px-6">
        <div className="text-center max-w-sm">
          <Lock className="w-10 h-10 mx-auto text-brass mb-4" />
          <h1 className="font-serif text-2xl text-cream">Accesso non autorizzato</h1>
          <p className="text-cream/70 mt-2">L'account <b>{user.email}</b> non è abilitato all'area amministratore.</p>
        </div>
      </div>
    );
  }

  return <AdminDashboard />;
}
